import React from 'react';
import Navbar from '../../components/Navbar';
import AccountHeader from '../../components/AccountHeader';
import BudgetList from '../../components/BudgetList';
import withAccount from '../../components/withAccount';
import accountProp from '../../propTypes/account';

const AccountBudgets = ({ account }) => (
  <>
    <Navbar account={account} />

    <AccountHeader account={account}>{(account) => `/accounts/${account.id}/budgets`}</AccountHeader>

    <hr />

    <div className="container">
      <div className="pt-4">
        <BudgetList key={account.id} account={account} />
      </div>
    </div>
  </>
);

AccountBudgets.propTypes = {
  account: accountProp.isRequired
};

export default withAccount(AccountBudgets);
